var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1338 6.50391C10.384 6.46879 10.5956 6.67003 10.5957 6.92285V13.4062L14.8555 17.6641C15.0374 17.8463 15.0238 18.1452 14.8145 18.292C13.7476 19.0537 12.441 19.5 11.0312 19.5C7.42543 19.4998 4.5 16.578 4.5 12.9707C4.50002 9.67072 6.9524 6.93919 10.1338 6.50391ZM17.2383 13C17.4619 13.0003 17.6373 13.188 17.6084 13.4092C17.423 14.754 16.7759 15.9501 15.8301 16.833C15.6857 16.9677 15.4589 16.9574 15.3193 16.8154L11.5 13H17.2383ZM12.0322 4C16.1562 4.00011 19.5 7.34327 19.5 11.4658C19.4997 11.7656 19.2462 11.999 18.9463 11.999H11.499V4.55371C11.499 4.25376 11.7322 4 12.0322 4Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco07);
export default __webpack_public_path__ + "static/media/Gnb_ico_07.0803ce5549a8164b04d7dfbac0f5d1d3.svg";
export { ForwardRef as ReactComponent };